import { ParsedFragmentEntity } from '@entities/ParsedFragment/Types';
import {
    ViewItemTypesModeEnum,
    ViewItemTypesModeType,
} from '@modules/Steps/Shared/Enums/ViewItemTypesModeEnum';
import { ItemTypeEntity } from '@entities/ItemType/Types';
import css from './Step3MobileContent.module.css';
import { CostSummaryHeaderStep3 } from '@modules/Steps/Shared/Widgets/CostSummaryHeaderStep3/CostSummaryHeaderStep3';
import { FragmentInfoMobileStep3 } from '@modules/Steps/Components/Step3/Step3MobileContent/FragmentInfoMobileStep3/FragmentInfoMobileStep3';
import { LaborAndToolsItemTypesInfoStep3 } from '@modules/Steps/Components/Step3/Step3DesktopContent/LaborAndToolsItemsTypesInfoStep3/LaborAndToolsItemTypesInfoStep3';
import React from 'react';

interface Props {
    fragments: ParsedFragmentEntity[];
    fragmentsViewMode: ViewItemTypesModeType;
    laborItemTypes: ItemTypeEntity[];
    toolItemTypes: ItemTypeEntity[];
}

const Step3MobileContent: React.FunctionComponent<Props> = ({
    fragments,
    fragmentsViewMode,
    toolItemTypes,
    laborItemTypes,
}) => {
    const filteredFragments = fragments.filter(
        fragment =>
            fragment.itemTypes.length > 0 &&
            fragment.itemTypes.some(
                itemType =>
                    itemType.qty > 0 &&
                    itemType.items &&
                    itemType.items?.length > 0
            )
    );

    return (
        <div className={css.content}>
            <CostSummaryHeaderStep3 viewMode={fragmentsViewMode} />

            <div className={css.list}>
                {filteredFragments.map(fragment => (
                    <FragmentInfoMobileStep3
                        fragment={fragment}
                        key={fragment.uuid}
                    />
                ))}

                {fragmentsViewMode ===
                    ViewItemTypesModeEnum.MaterialsLaborTools &&
                    laborItemTypes &&
                    laborItemTypes.length > 0 && (
                        <LaborAndToolsItemTypesInfoStep3
                            title="Labour required for task (optional)"
                            description="Indicative labour costs for each section, not purchasable."
                            itemTypes={laborItemTypes}
                        />
                    )}

                {fragmentsViewMode ===
                    ViewItemTypesModeEnum.MaterialsLaborTools &&
                    toolItemTypes &&
                    toolItemTypes.length > 0 && (
                        <LaborAndToolsItemTypesInfoStep3
                            title="Tools required for task (optional)"
                            description="You can select the tools you require, these are purchasable from the supplier you select."
                            itemTypes={toolItemTypes}
                        />
                    )}
            </div>
        </div>
    );
};

export default React.memo(Step3MobileContent);
